import React, { PropsWithChildren } from "react";
import HYLink from "../link/link";

export const ContactQQLink = 'http://wpa.qq.com/msgrd?v=3&uin=2850451486&site=qq&menu=yes';
export function createContactQQLink(qq: string) {
  return `http://wpa.qq.com/msgrd?v=3&uin=${qq}&site=qq&menu=yes`;
}

const ContactQQ: React.FC<PropsWithChildren<any>> = (props) => {
  return (
    <HYLink
      target="_blank"
      href={ContactQQLink}
    >
      {props.children}
    </HYLink>
  );
};

export default ContactQQ;
